module.exports = __webpack_public_path__ + "img/clock1.7dc2290e.png";